<elements-api
  [apiDescriptionUrl]="apiDescriptionUrl"
  [basePath]="basePath"
  [layout]="layout"
></elements-api>
